/* eslint-disable no-unused-vars */
import magnificPopup from 'magnific-popup';

export default () => {

  const $imageModal = $('.zoomable-image');

  if ($imageModal.length) {
    $imageModal.magnificPopup({
      type: 'image',
      closeBtnInside: false,
      mainClass: 'mfp-with-zoom',
      closeOnContentClick: true,
      zoom: {
        // By default this is false, so don't forget to enable it
        enabled: true,
        duration: 200,
        easing: 'ease-in-out',
        opener: (openerElement) => {
          // openerElement is the element on which popup was initialized, in this case its <a> tag
          // you don't need to add "opener" option if this code matches your needs, it's defailt one.
          return openerElement.is('figure') ? openerElement : openerElement.find('figure');
        }
      }

    });
  }

};
